/**
 * @fileoverview Agent definition for sequel-ideas-generator-v2.
 *
 * Generates three simple sequel/spin-off concepts (title + summary) from an existing story.
 * Part of the two-step ideation flow: this agent generates ideas, then story-planner expands the selected one.
 *
 * @category narrative.story.plot
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'sequel-ideas-generator-v2',
  kind: 'primitive',
  name: 'Sequel Ideas Generator',
  description: 'Generates three simple sequel/spin-off concepts (title + summary) from an existing story.',
  category: 'plot',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-01',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.story.plot',
    usedBy: ['use-sequel-ideas-generator-v2.ts', 'plot-ideation-card.tsx'],
    relatedAgents: ['plot-ideas-generator-v2', 'inspiration-ideas-generator-v2'],
  },
};
